<template>
  <div id="shade">
    <div>
      <div class="dia_head">
        〒{{ zipfmt }}
        <button type="button" @click="onClickClose">
          <img src="@assets/img/img_close.png" alt="閉じる" />
        </button>
      </div>
      <div class="dia_body">
        <table>
          <tr v-for="one in list" :key="one.id">
            <td
              v-bind:class="{
                on: selected !== null && one.id == selected.id,
              }"
              @click="onClickRow(one)"
            >
              {{ one.pref_name }}{{ one.city_name }}{{ one.town_name }}
            </td>
          </tr>
        </table>
      </div>
      <div class="dia_foot">
        <button type="button" @click="onClickOk" :disabled="selected === null">
          選択
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelectAdr",
  props: {
    zip: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    zipfmt: function () {
      return this.zip.substr(0, 3) + "-" + this.zip.substr(3);
    },
  },
  methods: {
    onClickRow: function (adr) {
      this.selected = adr;
      // console.log(adr);
    },
    onClickOk: function () {
      this.$emit("select", this.selected);
    },
    onClickClose: function () {
      this.$emit("close");
    },
  },
};
</script>
